import React, { useEffect, useState } from "react";
import Button from "../../UI/Buttons/Button.js";
import BasicQuestions from "./BasicQuestions.js";
import AdvanceQuestionProps from "./AdvanceQuestionProps.js";
import ManageOptions from "./ManageOptions.js";
import useApi from "../../../Hooks/useApi.js";
import showToast from "../../../Helpers/toast.js";
import {
  addQuestion,
  TYPEFOROPTIONS,
  updateQuestion,
} from "../../../Utils/questionnaireUtils.js";

const QuestionForm = ({
  currentSection,
  setQuestionList,
  questionList,
  sideFunctions,
  selectedQuestionData,
  questionTypes,
  orders,
  moduleType,
}) => {
  const mode = selectedQuestionData && selectedQuestionData.id ? "edit" : "add";
  const sectionTitle = currentSection && currentSection.name;
  const sectionId = currentSection && currentSection.sectionId;
  const [formdata, setFormdata] = useState({
    question: "",
    type: "",
    remarks: "",
    questionOptions: [],
    required: "no",
    formula: "",
    calculated: false,
    order: orders.value,
    sectionId: sectionId,
  });

  useEffect(() => {
    if (selectedQuestionData) {
      setFormdata({
        question: selectedQuestionData?.name,
        type: selectedQuestionData?.type,
        remarks: selectedQuestionData?.remarks,
        questionOptions: selectedQuestionData?.questionOptions,
        formula: selectedQuestionData.formula,
        calculated: selectedQuestionData?.type === "Calculate",
        icon: selectedQuestionData.icon,
        required: selectedQuestionData.required ? "yes" : "no",
        order: selectedQuestionData.order,
        sectionId: selectedQuestionData.sectionId,
      });
    }
  }, [selectedQuestionData]);

  const { request } = useApi();

  const handleAddQuestion = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    const isValidOptions = formdata.questionOptions.every(
      (option) => option.name.trim().length > 0
    );
    if (TYPEFOROPTIONS.includes(formdata?.type) && !isValidOptions) {
      showToast({
        message: "Option field cannot be empty",
        type: "error",
      });
      return;
    }

    try {
      const response =
        mode !== "edit"
          ? await addQuestion(
              request,
              {
                ...formdata,
                order: orders.value + 1,
                sectionId: currentSection.sectionId,
              },
              moduleType
            )
          : await updateQuestion(
              request,
              {
                ...formdata,
                questionId: selectedQuestionData.id,
              },
              moduleType
            );

      showToast({
        message: `Question ${
          mode === "edit" ? "Updated" : "Added"
        } Successfully`,
      });
      setQuestionList([
        response,
        ...questionList.filter((q) => q.id !== response.id),
      ]);

      sideFunctions();
    } catch (error) {
      showToast({
        message:
          error?.response?.data?.message || error?.message || "Error Occurred",
        type: "error",
      });
    }
  };

  return (
    <div className="">
      <h1 className="pl-2 pb-6 text-lg">
        {mode !== "edit" ? "Add a new Question" : "Edit question"} for section:
        <span className="font-bold italic">{sectionTitle}</span>
      </h1>
      <div className="space-y-2 ">
        <BasicQuestions
          data={formdata}
          setter={setFormdata}
          questionTypes={questionTypes}
        />

        {formdata.type && TYPEFOROPTIONS.includes(formdata.type) && (
          <ManageOptions data={formdata} setter={setFormdata} />
        )}
        <AdvanceQuestionProps
          data={formdata}
          setter={setFormdata}
          visibility={false}
        />
      </div>
      <div className="flex items-center gap-4">
        <div className="py-6 space-x-2 mx-auto">
          <Button
            type="small"
            style={{ backgroundColor: "#7DDBFF" }}
            backgroundColor={"#7DDBFF"}
            label={mode !== "edit" ? "Submit Question" : "Edit question"}
            handler={handleAddQuestion}
          />
        </div>
      </div>
    </div>
  );
};

export default QuestionForm;
